import { InstallmentCalculationType } from '../types/InstallmentCalculationType';
import DateTimeParser from '../../../../../../core/utils/DateTimeParser';

export const ManualInstallmentPlanService = {
  mapDataToTableRows: (
    data: InstallmentCalculationType[],
    caseBalance: number,
    isCurrencyVisible: boolean,
    currency: string
  ) => {
    const rows: any = [];

    data.forEach((item, i) => {
      rows.push({
        id: i,
        dueDate: DateTimeParser.toLocaleDateString(item.dueDate),
        termAmount: ManualInstallmentPlanService.ToCurrency(
          item.termAmount,
          currency,
          isCurrencyVisible
        ),
        remainingCapital: ManualInstallmentPlanService.ToCurrency(
          item.termBalance.capital,
          currency,
          isCurrencyVisible
        ),
        remainingInterest: ManualInstallmentPlanService.ToCurrency(
          item.termBalance.interest,
          currency,
          isCurrencyVisible
        ),
        remainingOther: ManualInstallmentPlanService.ToCurrency(
          item.termBalance.total - (item.termBalance.capital + item.termBalance.interest),
          currency,
          isCurrencyVisible
        ),
        remainingBalance: ManualInstallmentPlanService.ToCurrency(
          item.termBalance.total,
          currency,
          isCurrencyVisible
        ),
      });
    });

    return rows;
  },
  ToCurrency: (number: string | number, currencySymbol: string, isCurrencyVisible: boolean) => {
    let value = number.toLocaleString('nb-NO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    value = value.replace(/\u00A0/g, ' ');

    if (isCurrencyVisible) {
      value = `${value} ${currencySymbol}`;
    }

    return value;
  },
  parseNumber: (value: string): number => {
    return parseFloat(value.replace(',', '.').replace(/\s/g, ''));
  },
};
